import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import CompanyClasses from "../../../landing-pages/Company/company.module.css";
import { SortDirection } from "../../../models/enums/SortDirectionEnum";
import PagedListModel from "../../../models/common/PagedListModel";
import modalUtils from "../../../utils/modal-utils";
import toasterUtils from "../../../utils/toaster-utils";
import CompanyDashboardModel from "../../../models/company/dashboard/response/CompanyDashboardModel";
import IdNameModel from "../../../models/common/IdNameModel";
import masterDataService from "../../../services/master-data-service";
import JobPostingDashboardGridComponent from "./JobPostingDashboardGridComponent";
import { PagingEnum } from "../../../models/enums/IAIEnum";
import adminDashboardService from "../../../services/admin/admin-dashboard-service";
import AdminJobPostingSearchInputModel from "../../../models/admin/company/request/AdminJobPostingSearchInputModel";
import { FormControl, InputLabel, MenuItem, Select, Button, Autocomplete, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { GuidEnum } from "../../../models/enums/GuidEnum";

interface AdminJobPostingDashboardProps {
    companiesList: IdNameModel[];
    promarySkillList: IdNameModel[];
    statusList: IdNameModel[];
};

const JobPostingDashboardComponent = (props: AdminJobPostingDashboardProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [jobPostingPagedList, setJobPostingPagedList] = useState<PagedListModel<CompanyDashboardModel>>();
    const [jobPostingList, setJobPostingList] = useState<CompanyDashboardModel[]>([]);
    const [refreshJobPosting, setRefreshJobPosting] = useState<number>(2);
    const [companySearch, setCompanySearch] = useState<string>("All");
    const [primarySkillSearch, setPrimarySkillSearch] = useState<number>(0);
    const [jobCodeSearch, setJobCodeSearch] = useState<string>("All");
    const [statusSearch, setStatusSearch] = useState<number>(0);
    const [page, setPage] = useState<number>(PagingEnum.page);
    const [pageSize, setPageSize] = useState<number>(PagingEnum.pageSize);
    const [sortColumn, setSortColumn] = useState<string>("CreatedDate");
    const [sortDirection, setSortDirection] = useState<number>(PagingEnum.sortDirectionDesc);
    const [pageSizesList, setPageSizesList] = useState<number[]>([]);

    useEffect(() => {
        loadPageSizes();
        getJobPostings(getSearchFilters(page, pageSize, sortColumn, sortDirection));
    }, []);

    const loadPageSizes = () => {
        masterDataService.loadPageSizesForPaging().then((res) => {
            setPageSizesList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getSearchFilters = (page: number, pageSize: number, sortColumn: string, sortDirection: number) => {
        var inputData: AdminJobPostingSearchInputModel = {
            userId: "",
            companyIds: (companySearch === null || companySearch === "" || companySearch === "All") ? props.companiesList.map(item => item.guId) : [companySearch],
            jobCode: jobCodeSearch === "All" ? "" : jobCodeSearch,
            statusId: statusSearch === 0 ? null : statusSearch,
            primarySkillId: primarySkillSearch === 0 ? null : primarySkillSearch,
            page: page,
            pageSize: pageSize,
            sort: sortColumn,
            sortDir: sortDirection
        };
        return inputData;
    };

    const getJobPostings = (inputData: AdminJobPostingSearchInputModel) => {
        setRefreshJobPosting(2);
        if (loggedInUser?.profileId) {
            inputData.userId = loggedInUser?.profileId;
            modalUtils.showLoader();
            adminDashboardService.getJobPostingsDashboardForIAIBackOffice(inputData).then((res) => {
                modalUtils.closeModal();
                setJobPostingList([]);
                setJobPostingPagedList(res);
                setJobPostingList(res.items);
                setRefreshJobPosting(refreshJobPosting * 5);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const onPageChangeActionHandler = (newPage: number) => {
        setPage(newPage);
        getJobPostings(getSearchFilters(newPage, pageSize, sortColumn, sortDirection));
    };

    const onPageSizeChangeActionHandler = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(PagingEnum.page);
        getJobPostings(getSearchFilters(PagingEnum.page, newPageSize, sortColumn, sortDirection));
    };

    return (
        <div id="main-wrapper">
            <div className="apply-filter">
                Filter Postings <i className="fas fa-filter" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"></i>
            </div>
            <div className="offcanvas offcanvas-end" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasRightLabel">Apply Filter</h5>
                    <a type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></a>
                </div>
                <div className="offcanvas-body">
                    <div className="row">
                        <div>
                            <FormControl fullWidth margin="none">
                                <Autocomplete options={props.companiesList} value={props.companiesList.find((x) => x.guId === companySearch) || null}
                                    onChange={(_, newValue) => setCompanySearch(newValue ? newValue.guId : GuidEnum.Empty)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Company" size="small" margin="normal" fullWidth />
                                    )}
                                />
                            </FormControl>
                        </div>
                        <div>
                            <FormControl fullWidth margin="none">
                                <Autocomplete options={props.promarySkillList} value={props.promarySkillList.find((x) => x.id === primarySkillSearch) || null}
                                    onChange={(_, newValue) => setPrimarySkillSearch(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Primary Skill" size="small" margin="normal" fullWidth />
                                    )}
                                />
                            </FormControl>
                        </div>
                        <div>
                            <FormControl fullWidth margin="none">
                                <Autocomplete options={jobPostingList} value={jobPostingList.find((x) => x.jobCode === jobCodeSearch) || null}
                                    onChange={(_, newValue) => setJobCodeSearch(newValue ? newValue.jobCode : '')} getOptionLabel={(option) => option?.jobCode || ""} isOptionEqualToValue={(option, value) => option.jobCode === value.jobCode}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Job Code" size="small" margin="normal" fullWidth />
                                    )}
                                />
                            </FormControl>
                        </div>
                        <div>
                            <FormControl fullWidth margin="none">
                                <Autocomplete options={props.statusList} value={props.statusList.find((x) => x.id === statusSearch) || null}
                                    onChange={(_, newValue) => setStatusSearch(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Status" size="small" margin="normal" fullWidth />
                                    )}
                                />
                            </FormControl>
                        </div>
                        <div className="text-center">
                            <Button variant="contained" color="primary" type="submit"
                                onClick={() => getJobPostings(getSearchFilters(page, pageSize, sortColumn, sortDirection))} startIcon={<SearchIcon />}>
                                Search
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {refreshJobPosting > 2 &&
                <JobPostingDashboardGridComponent
                    key={refreshJobPosting}
                    jobPostingList={jobPostingList}
                    status={props.statusList}
                    totalSize={jobPostingPagedList?.totalCount ? jobPostingPagedList?.totalCount : jobPostingList.length}
                    currentPage={page + 1}
                    pagesize={pageSize}
                    sortColumn={sortColumn}
                    sortDirection={sortDirection === SortDirection.Asc ? "asc" : "desc"}
                    pageSizesList={pageSizesList}
                    onPageChangeAction={onPageChangeActionHandler}
                    onPageSizeChangeAction={onPageSizeChangeActionHandler} />
            }
        </div>
    );
};
export default JobPostingDashboardComponent;